import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

const StarsIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.L}
      svgProps={{
        viewBox: '0 0 24 24'
      }}
      {...props}
    >
      <path
        d="M14.822 2.40002L16.6522 7.34623L21.5984 9.1765L16.6522 11.0068L14.822 15.953L12.9917 11.0068L8.0455 9.1765L12.9917 7.34623L14.822 2.40002Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M6.35138 13.6941L7.95021 16.0483L10.3043 17.6471L7.95021 19.2459L6.35138 21.6L4.75255 19.2459L2.39844 17.6471L4.75255 16.0483L6.35138 13.6941Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default StarsIcon;
